import { render, staticRenderFns } from "./Publicacoes.vue?vue&type=template&id=71182f74&"
import script from "./Publicacoes.vue?vue&type=script&lang=js&"
export * from "./Publicacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports